<template>
  <ContentPage back>
    <template #header>
      <content-page-title>
        {{ me.user.name }}
      </content-page-title>
    </template>

    <v-data-table
      :headers="headers"
      :items="allUsers"
      :mobile-breakpoint="0"
      hide-default-footer
      class="rounded-lg"
    >
      <template #item.name="{ item }">
        <UserDialog :pro_user="item" />
      </template>

      <template #item.contact="{ item }">
        <v-icon v-if="item.contact_method === 'email'" small color="primary">
          mdi-email-outline
        </v-icon>
        <v-icon v-else small color="primary">mdi-phone-outline</v-icon>
        {{ item.contact }}
      </template>

      <template #item.opted_out="{ item }">
        <v-icon v-if="item.opted_out" color="red">mdi-phone-alert-outline</v-icon>
      </template>

      <template #header.actions>
        <UserDialog />
      </template>

      <template #item.actions="{ item }">
        <UserActions :pro_user="item" @menuAction="onMenuAction" />
      </template>
    </v-data-table>
    <DeleteDialog :pro_user="selected_pro" v-model="show_delete" />
    <RemindDialog :pro_user="selected_pro" v-model="show_remind" />
  </ContentPage>
</template>

<script>
import UserActions from './components/UserActions'
import DeleteDialog from './dialogs/Delete'
import RemindDialog from './dialogs/Remind'
import UserDialog from './dialogs/User'
import { ContentPage, ContentPageTitle } from '@/components/pages'
import { mapActions, mapGetters } from 'vuex'
import formatters from '@/lib/formatters'

export default {
  name: 'UserDetailView',

  components: {
    ContentPage, ContentPageTitle, DeleteDialog,
    RemindDialog, UserActions, UserDialog
  },

  data() {
    let left = { class: 'pl-2 pr-0', cellClass: 'pl-2 pr-0' }
    let middle = { class: 'pl-1 pr-0', cellClass: 'pl-1 pr-0' }
    let right = { class: 'pl-2 pr-1', cellClass: 'pl-1 pr-1' }

    return {
      selected_pro: {},
      show_delete: false,
      show_remind: false,

      headers: [
        { text: 'User', sortable: false, value: 'name',  ...left },
        { text: 'Contact', sortable: false, value: 'contact', ...middle },
        { align: 'center', sortable: false, value: 'opted_out', ...middle },
        { align: 'center', sortable: false, value: 'actions',  ...right },
      ],
    }
  },

  computed: {
    ...mapGetters('auth', ['me']),
    ...mapGetters('pro_users', ['allUsers'])
  },
  

  methods: {
    ...mapActions('pro_users', ['loadAll']),
    ...formatters,

    onMenuAction({ method, pro_user }) {
      this.selected_pro = pro_user
      switch(method) {
        case 'delete':
          this.show_delete = true; break;
        case 'remind':
          this.show_remind = true; break;
      }
    },
  },

  created() {
    this.loadAll()
  }
}
</script>
